import { SupportedLocale } from "@lectra/mui-library";

var local_EN = require("./local_EN.json");
var local_FR = require("./local_FR.json");
var local_IT = require("./local_IT.json");
var local_PT = require("./local_PT.json");
var local_DE = require("./local_DE.json");
var local_ES = require("./local_ES.json");
var local_ZH = require("./local_ZH.json");
var local_JA = require("./local_JA.json");
/*
var local_KO= require("./local_KO.json");
var local_HI= require("./local_HI.json");*/

export var allLocals = {
  "en-US": local_EN,
  "fr-FR": local_FR,
  "it-IT": local_IT,
  "pt-PT": local_PT,
  "de-DE": local_DE,
  "es-ES": local_ES,
  "zh-CN": local_ZH,
  "ja-JP": local_JA,
};
var getBrowserLanguage = function (allLocals) {
  const language = navigator.language ? navigator.language : navigator.userLanguage;
  return language;
};

var getPreviousLanguage = function () {
  if (!localStorage) return null;
  return localStorage.getItem("LANGUAGE");
};

var getLanguageFromUrl = function () {
  //const myUrl = new URL(document.location.href);
  let res = null;
  if (document.location.search.length === 0) return null;
  let params = document.location.search.substr(1); //removes '?' char

  let paramsArray = params.split("&");

  if (paramsArray.length === 0) return null;
  paramsArray.forEach(function (el) {
    let paramValue = el.split("=");
    if (paramValue.length === 2 && paramValue[0] === "language") {
      res = paramValue[1].toUpperCase();
      return;
    }
  });

  return res ? res.toUpperCase() : null;
};
export var initialLanguage = getLanguageFromUrl() || getPreviousLanguage() || getBrowserLanguage(allLocals);

//english by default if language is not supported by app
if (!allLocals[initialLanguage]) {
  initialLanguage = SupportedLocale.EN;
}

export var currentLocals = function (locale = initialLanguage) {
  locale = locale === "" ? SupportedLocale.EN : locale;
  return allLocals[locale];
};
